module.exports = __webpack_public_path__ + "static/media/ItalyFerra.0e1ec6fe.png";